// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Grid-module--cds--assistive-text--fa8cf";
export var cdsHideFeedback = "Grid-module--cds--hide-feedback--57f7e";
export var cdsShowFeedback = "Grid-module--cds--show-feedback--d9abb";
export var cdsSkeleton = "Grid-module--cds--skeleton--ff375";
export var cdsVisuallyHidden = "Grid-module--cds--visually-hidden--f39cb";
export var column = "Grid-module--column--0cbcd";